<div class="modal fade" id="modalEducation" tabindex="-1" aria-labelledby="modalEducationLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalEducationLabel">Educación</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row" [formGroup]="form">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Institución</label>
                            <div>
                                 <app-dropdown [options]="institutions" formControlName="institutionId"></app-dropdown>
                                  @if (form.get('institutionId')?.invalid && (form.get('institutionId')?.touched || form.get('institutionId')?.dirty)) {
                                    @if (form.get('institutionId')?.errors?.['required'] == true) {
                                        <div class="invalid-field">
                                            Este campo es requerido
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Nivel Académico</label>
                            <div>
                                <app-dropdown [options]="educationLevels" formControlName="educationLevelId"></app-dropdown>
                                  @if (form.get('educationLevelId')?.invalid && (form.get('educationLevelId')?.touched || form.get('educationLevelId')?.dirty)) {
                                    @if (form.get('educationLevelId')?.errors?.['required'] == true) {
                                        <div class="invalid-field">
                                            Este campo es requerido
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Estudios Realizados</label>
                            <div>
                                <app-dropdown [options]="careers" formControlName="careerId"></app-dropdown>
                                  @if (form.get('careerId')?.invalid && (form.get('careerId')?.touched || form.get('careerId')?.dirty)) {
                                    @if (form.get('careerId')?.errors?.['required'] == true) {
                                        <div class="invalid-field">
                                            Este campo es requerido
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label>Campo de estudio</label>
                            <div>
                                <input formControlName="fieldStudy" type="text" class="form-control" 
                                [ngClass]="{'is-invalid': form.get('fieldStudy')?.invalid && (form.get('fieldStudy')?.touched || form.get('fieldStudy')?.dirty)}"/>
                                @if (form.get('fieldStudy')?.invalid && (form.get('fieldStudy')?.touched || form.get('fieldStudy')?.dirty)) {
                                    @if (form.get('fieldStudy')?.errors?.['required'] == true) {
                                        <div class="invalid-feedback">
                                            Este campo es requerido
                                        </div>
                                    }
                                    @if (form.get('fieldStudy')?.hasError('maxlength')) {
                                        <div class="invalid-feedback">
                                            Este campo no puede exceder los {{form.get('fieldStudy')?.errors?.['maxlength']?.requiredLength}} caracteres
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Estatus</label>
                            <div>
                                <app-dropdown [options]="resumeEducationStatus" formControlName="resumeEducationStatusId" [showSearch]="false"></app-dropdown>
                                @if (form.get('resumeEducationStatusId')?.invalid && (form.get('resumeEducationStatusId')?.touched || form.get('resumeEducationStatusId')?.dirty)) {
                                  @if (form.get('resumeEducationStatusId')?.errors?.['required'] == true) {
                                      <div class="invalid-field">
                                          Este campo es requerido
                                      </div>
                                  }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Fecha de inicio</label>
                            <div>
                                <input formControlName="startDate" type="date" class="form-control" 
                                [ngClass]="{'is-invalid': form.get('startDate')?.invalid && (form.get('startDate')?.touched || form.get('startDate')?.dirty)}"/>
                                @if (form.get('startDate')?.invalid && (form.get('startDate')?.touched || form.get('startDate')?.dirty)) {
                                    @if (form.get('startDate')?.errors?.['required'] == true) {
                                        <div class="invalid-feedback">
                                            Este campo es requerido
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label>Fecha de finalización</label>
                            <div>
                                <input formControlName="endDate" type="date" class="form-control" 
                                [ngClass]="{'is-invalid': form.get('endDate')?.invalid && (form.get('endDate')?.touched || form.get('endDate')?.dirty)}"/>
                                @if (form.get('endDate')?.invalid && (form.get('endDate')?.touched || form.get('endDate')?.dirty)) {
                                    @if (form.get('endDate')?.errors?.['required'] == true) {
                                        <div class="invalid-feedback">
                                            Este campo es requerido
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label>Descripción</label>
                            <div>
                                <textarea formControlName="description" class="form-control" rows="5"
                                [ngClass]="{'is-invalid': form.get('description')?.invalid && (form.get('description')?.touched || form.get('description')?.dirty)}"></textarea>
                                @if (form.get('description')?.invalid && (form.get('description')?.touched || form.get('description')?.dirty)) {
                                    @if (form.get('description')?.errors?.['required'] == true) {
                                        <div class="invalid-feedback">
                                            Este campo es requerido
                                        </div>
                                    }
                                    @if (form.get('description')?.hasError('maxlength')) {
                                        <div class="invalid-feedback">
                                            Este campo no puede exceder los {{form.get('description')?.errors?.['maxlength']?.requiredLength}} caracteres
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="mt-3 mb-3" />
                <div class="mt-2 mb-2 text-end">
                    <button (click)="closeModal()" type="button" class="btn btn-secondary me-2">
                        Cancelar
                    </button>
                    <button (click)="submit()" type="button" class="btn btn-primary">
                        @if(!isLoading()){
                            Guardar
                         }@else {
                             <div class="spinner-border spinner-border-sm text-light" role="status">
                                 <span class="visually-hidden">Loading...</span>
                             </div>
                             Guardando
                         }
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>